export const wmaMimeTypes = ["audio/x-ms-wma", "video/x-ms-wma"];
